const doc = [({"ko":({"adminComponentCompanyInvoice":({"companyInvoiceIndexTitle":"인보이스 목록"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;